import { render, staticRenderFns } from "./ProductTypeSelector.vue?vue&type=template&id=2b29d7ed&scoped=true"
import script from "./ProductTypeSelector.vue?vue&type=script&lang=ts"
export * from "./ProductTypeSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProductTypeSelector.vue?vue&type=style&index=0&id=2b29d7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b29d7ed",
  null
  
)

export default component.exports